import { Await, Link, defer, useLoaderData } from 'react-router-dom';
import {
  H1,
  Card,
  Badge,
  Table,
  TableBody,
  TableData,
  TableHead,
  TableRow,
  Button,
  TableLoading,
} from 'ui-rollup';
import styles from './dashboard.module.css';
import { Suspense } from 'react';
import { Dashboard as IDashboard } from '../../types/dashboard';
import { getJwt } from '../../utils/getJwt';
import { fetchData } from '../../utils/fetchData';

export const loader = () => {
  const dashboard = fetchData<{ done: number; pending: number }>(
    `${process.env.REACT_APP_BACKEND_API}/dashboard`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    },
  );

  return defer({ dashboard });
};

export const Dashboard = () => {
  const data = useLoaderData() as {
    dashboard: IDashboard;
  };
  const user = getJwt();

  return (
    <>
      <div className={styles.userContainer}>
        <H1>Hello {user.name} 👋</H1>
        <Link to="/create">
          <Button>Create a new invoice</Button>
        </Link>
      </div>
      <div className={styles.statusContainer}>
        <Suspense fallback={<Card label="Done" isLoading={true} icon="✅" />}>
          <Await resolve={data.dashboard}>
            {(dashboard) => (
              <Card label="Done" text={dashboard.done} icon="✅" />
            )}
          </Await>
        </Suspense>
        <Suspense
          fallback={<Card label="Pending" isLoading={true} icon="😡" />}
        >
          <Await resolve={data.dashboard}>
            {(dashboard) => (
              <Card label="Pending" text={dashboard.pending} icon="😡" />
            )}
          </Await>
        </Suspense>
      </div>
      <Suspense fallback={<TableLoading rowCount={5} />}>
        <Await resolve={data.dashboard}>
          {({ recents }: IDashboard) =>
            recents.length ? (
              <Table>
                <TableRow>
                  <TableHead># No.</TableHead>
                  <TableHead>Client</TableHead>
                  <TableHead>Date</TableHead>
                  <TableHead>Amount</TableHead>
                  <TableHead colSpan={2}>Status</TableHead>
                </TableRow>
                <TableBody>
                  {recents.map((recent, index) => {
                    const date = new Date(
                      recent.dateOfIssue,
                    ).toLocaleDateString(undefined, {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric',
                    });

                    return (
                      <TableRow key={recent.id}>
                        <TableData>{index + 1}</TableData>
                        <TableData>{recent.client.name}</TableData>
                        <TableData>{date}</TableData>
                        <TableData>{recent.total}</TableData>
                        <TableData>
                          <Badge
                            variant={recent.isPaid ? 'success' : 'secondary'}
                          >
                            {recent.isPaid ? 'Paid' : 'Pending'}
                          </Badge>
                        </TableData>
                        <TableData>
                          <Link to={`/history/${recent.id}`}>View more</Link>
                        </TableData>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : (
              <div className={styles.nothingContainer}>
                <div className={styles.nothingIcon}>🙈</div>
                <p className={styles.nothingText}>Nothing to show here</p>
              </div>
            )
          }
        </Await>
      </Suspense>
    </>
  );
};
